import {useRef} from 'react';
import {Table} from 'antd';
import {toFSDate} from "../../util/timeutils";
import {Row} from 'antd';
import {PurchaseOrderStateWidget} from "./PurchaseOrderStateWidget";
import {Link} from 'react-router';
import {getColumnSearchProps} from "../widget/SearchProps";

export const ExistingPurchaseOrderTable = ({items, onRefresh, onApiFail, isFulfillment=false, props}) => {

    // for use with search props
    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Order Number',
            dataIndex: 'poNumber',
            key: 'poNumber',
            ...getColumnSearchProps(`poNumber`, searchInput),
            sorter: (a, b) => a.poNumber.toLowerCase().localeCompare(b.poNumber.toLowerCase()),
            render: (val, record, index) => {
                return <Link to={`/purchaseorder/${record.id}`}>{val}</Link>
            }
        },
        {
            title: 'Buyer',
            dataIndex: 'firstname',
            key: 'buyer',
            render: (val, record) => {
                return `${val} ${record.lastname}`
            },
            ...getColumnSearchProps(`firstname`, searchInput),
            sorter: (a, b) => {
                const aname = `${a.firstname} ${a.lastname}`.toLowerCase();
                const bname = `${b.firstname} ${b.lastname}`.toLowerCase();
                return aname.localeCompare(bname)
            },
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
        },
        {
            title: 'State',
            dataIndex: 'state',
            key: 'state',
            render: (val, record, index) => {
                return <div>
                    <Row><PurchaseOrderStateWidget purchaseOrder={record} onRefresh={onRefresh} isFulfillment={isFulfillment} onApiFail={onApiFail}/></Row>
                </div>
            },
            sorter: (a, b) => a.state - b.state
        },
        {
            title: 'Due Date',
            dataIndex: 'dueDate',
            key: 'dueDate',
            render: (val) => {
                return toFSDate(new Date(val));
            },
            sorter: (a, b) => (new Date(a.dueDate))- (new Date(b.dueDate)),
        },
    ];

    const purchaseOrders = items.map(v => {
        return {...v, key: v.id}
    })

    return <Table dataSource={purchaseOrders} columns={columns} />
}